export default __webpack_public_path__ + "static/shop-image4-7dee58953a2304e5fb2dca8acbad62c1.jpg";